module.exports = __webpack_public_path__ + "img/workshop-zip-good-bad.535c105f.png";